// Adding leading zeros
export function lPad(value: number, size: number) {
  return Array(Math.max(size - String(value).length + 1, 0)).join('0') + value;
}